var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollarSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 18,
    viewBox: "0 0 10 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.521973 12.0896H2.39461C2.39461 13.1008 3.67737 13.9622 5.20357 13.9622C6.72977 13.9622 8.01252 13.1008 8.01252 12.0896C8.01252 11.0596 7.03875 10.6851 4.97885 10.1889C2.99385 9.69261 0.521973 9.07464 0.521973 6.47167C0.521973 4.79566 1.89836 3.37246 3.79909 2.89493V0.85376H6.60805V2.89493C8.50877 3.37246 9.88516 4.79566 9.88516 6.47167H8.01252C8.01252 5.46045 6.72977 4.59904 5.20357 4.59904C3.67737 4.59904 2.39461 5.46045 2.39461 6.47167C2.39461 7.50162 3.36838 7.87615 5.42828 8.3724C7.41328 8.86865 9.88516 9.48662 9.88516 12.0896C9.88516 13.7656 8.50877 15.1888 6.60805 15.6663V17.7075H3.79909V15.6663C1.89836 15.1888 0.521973 13.7656 0.521973 12.0896Z",
    fill: "#50AD20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarSymbol);
export default __webpack_public_path__ + "static/media/DollarSymbol.bb03b44e80d8fd8a212ec846dec8c46a.svg";
export { ForwardRef as ReactComponent };